import React from 'react';
import { chain, includes, filter, orderBy } from 'lodash';
import ReactPaginate from 'react-paginate';
import enhance from './Discover.enhancer';
import Paper from '@material-ui/core/Paper';
import { Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import CardGiftcardIcon from '@material-ui/icons/CardGiftcard';
import PropTypes from 'prop-types';
import Toolbar from '@material-ui/core/Toolbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube } from '@fortawesome/free-brands-svg-icons';
import OutlinedInputBox from '../../components/shared/components/OutlinedInputBox';
import Button from '@material-ui/core/Button';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Divider from '@material-ui/core/Divider';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Box from '@material-ui/core/Box';
import Fab from '@material-ui/core/Fab';
import RootRef from '@material-ui/core/RootRef';
import { getCountryValueFromKey } from '../../helpers/countryHelper';
import { RadioIcon, RadioFillIcon, grey, primary } from '../../style';
import { industrySelections } from '../../constants';
import TextField from '@material-ui/core/TextField';
import LinkText from '../../components/shared/components/LinkText';

class Discover extends React.Component {
  constructor() {
    super();

    this.initialState = {
      campaigns: [],
      tableRows: [],
      currentPage: 0,
      pagesCount: 0,
      searchTerm: '',
      filtersShown: false,
      filters: {
        rewardType: 'any',
        influenceLevel: 'any',
        gender: 'any',
        payoutMin: null,
        payoutMax: null,
        industry: 'All'
      },
      sort: 'newest',
      offset: 0,
      pageCount: 0,
      filterTitleHeight: 0
    };

    this.state = {
      ...this.initialState
    };

    this.filterTitleRef = React.createRef();
  }

  componentDidMount() {
    this.loadCampaigns();
    this.setState({
      filterTitleHeight: this.filterTitleRef.current.offsetHeight
    });
  }

  loadCampaigns() {
    let query = this.props.firestore.collection('campaigns');
    const campaigns = [];

    query.get().then(campaignSnapshot => {
      if (!campaignSnapshot.docs.length) {
        this.setState({
          lastCampOnPage: null,
          campaigns: []
        });
      }

      // load the campaign data
      campaignSnapshot.forEach(doc => {
        const campData = doc.data();
        campData.id = doc.id;
        campData.country = getCountryValueFromKey(campData.country);
        if (campData.status === 'ACTIVE' && !campData.isPrivate) {
          campaigns.push(campData);
        }
      });

      let requests = campaigns.map(campaign => {
        return new Promise(resolve => {
          this.props.firestore
            .get({
              collection: 'users',
              doc: campaign.creator
            })
            .then(user => {
              if (user && campaign.creator) {
                const userData = user.data();
                if (userData) {
                  campaign.companyId = user.id;
                  campaign.companyName = userData.displayName;
                  campaign.picUrl = userData.profilePictureUrl;
                }
              }
              resolve(campaign);
            });
        });
      });

      Promise.all(requests).then(campaigns => {
        this.setState({
          campaigns: orderBy(campaigns, ['createdAt'], ['desc'])
        });
        this.applyFilters();
      });
    });
  }

  applyFilters() {
    this.setState({
      currentPage: 0
    });

    let query = chain(this.state.campaigns);

    //search term
    if (this.state.searchTerm) {
      query = query.filter(camp =>
        includes(camp.name.toLowerCase(), this.state.searchTerm.toLowerCase())
      );
    }
    // reward type filter
    switch (this.state.filters.rewardType) {
      case 'money':
        query = query.filter(camp => camp.payoutMin > 0);
        break;
      case 'product':
        query = query.filter(camp => camp.productOnly);
        break;
      case 'productAndMoney':
        query = query.filter(camp => camp.productAndCommission);
        break;
    }

    // influence level filter
    switch (this.state.filters.influenceLevel) {
      case 'micro':
        query = query.filter(camp => camp.influenceLevel === 'micro');
        break;
      case 'macro':
        query = query.filter(camp => camp.influenceLevel === 'macro');
        break;
      case 'mega':
        query = query.filter(camp => camp.influenceLevel === 'mega');
        break;
    }

    // gender filter
    switch (this.state.filters.gender) {
      case 'male':
        query = query.filter(camp => camp.gender === 'Male');
        break;
      case 'female':
        query = query.filter(camp => camp.gender === 'Female');
        break;
    }

    //apply industry
    if (this.state.filters.industry && this.state.filters.industry !== 'All') {
      query = query.filter(
        camp => camp.productCategory == this.state.filters.industry
      );
    }

    //payout minimum filter
    if (this.state.filters.payoutMin === 0 || this.state.filters.payoutMin) {
      query = query.filter(
        camp => camp.payoutMin > this.state.filters.payoutMin
      );
    }

    if (this.state.filters.payoutMax) {
      query = query.filter(
        camp => camp.payoutMax < this.state.filters.payoutMax
      );
    }

    const result = query.value();

    //set currentCount
    const pages = Math.ceil(result.length / 10);
    this.setState({
      pagesCount: pages,
      filteredCampaigns: result,
      tableRows: result.slice(0, 10)
    });
  }

  handleChangePage(event) {
    if (event) {
      const newPage = event.selected;
      const rowStart = newPage * 10;
      this.setState({
        currentPage: newPage,
        tableRows: this.state.filteredCampaigns.slice(rowStart, rowStart + 10)
      });
    }
  }

  handleSearchChange(e) {
    const result = filter(this.state.filteredCampaigns, camp =>
      includes(camp.name.toLowerCase(), e.target.value.toLowerCase())
    );
    this.setState({
      pagesCount: Math.ceil(result.length / 10),
      searchTerm: e.target.value,
      currentPage: 0,
      // filteredCampaigns: result,
      tableRows: result.slice(0, 10)
    });
  }

  handleFiltersClick() {
    this.setState(prevState => ({
      filtersShown: !prevState.filtersShown
    }));
  }

  rewardTypeHandler(e) {
    this.setState({
      filters: {
        ...this.state.filters,
        rewardType: e.target.value
      }
    });
  }

  influenceHandler(e) {
    this.setState({
      filters: {
        ...this.state.filters,
        influenceLevel: e.target.value
      }
    });
  }

  genderHandler(e) {
    this.setState({
      filters: {
        ...this.state.filters,
        gender: e.target.value
      }
    });
  }

  payoutMinChangeHandler(e) {
    this.setState({
      filters: {
        ...this.state.filters,
        payoutMin: parseInt(e.target.value)
      }
    });
  }

  payoutMaxChangeHandler(e) {
    this.setState({
      filters: {
        ...this.state.filters,
        payoutMax: parseInt(e.target.value)
      }
    });
  }

  changeFilterHandler = e => {
    this.setState({
      filters: {
        ...this.state.filters,
        [e.target.name]: e.target.value
      }
    });
  };

  handleCampaignClick(campaignId) {
    this.props.history.push(`/campaigns/${campaignId}`);
  }

  navigateToCompany = userId => {
    this.props.history.push(`/user/${userId}/profile`);
  };

  handleChangeSort(event) {
    this.setState({
      sort: event.target.value
    });
  }

  handlePageClick = data => {
    const selected = data.selected;
    this.setState({
      offset: selected
    });
  };

  render() {
    const { classes } = this.props;
    const {
      currentPage,
      pagesCount,
      searchTerm,
      filtersShown,
      tableRows,
      sort,
      offset,
      defaultPageRange,
      pageCount,
      filterTitleHeight,
      filters
    } = this.state;
    const {
      rewardType,
      influenceLevel,
      gender,
      payoutMin,
      payoutMax
    } = filters;

    return (
      <React.Fragment>
        <main className={classes.layout}>
          <Grid
            className={classes.header}
            container
            direction="row"
            justify="space-between"
            alignItems="flex-end"
          >
            <Grid item>
              <Typography
                variant="h3"
                id="tableTitle"
                className={classes.title}
              >
                Discover
              </Typography>
            </Grid>
            {/* <Grid item>
              <Typography variant="h6" id="tableTitle">
                <Grid container direction="row" spacing={2}>
                  <Grid item>
                    <Box color="text.primary">Suitable for Me</Box>
                  </Grid>
                  <Grid item>
                    <Box color="text.secondary">All offers</Box>
                  </Grid>
                </Grid>
              </Typography>
            </Grid> */}
          </Grid>
          <Paper className={classes.root}>
            <Toolbar>
              <Grid container direction="column" className={classes.space}>
                <Grid container>
                  <Grid item md={8} xs={12}>
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      spacing={2}
                    >
                      <Grid item sm={6} xs={12}>
                        <FormControl className={classes.search}>
                          <Box color="text.hint">
                            <SearchIcon />
                          </Box>
                          <InputBase
                            className={classes.searchInput}
                            placeholder="Search Campaign Name"
                            inputProps={{
                              'aria-label': 'Search Campaign Name'
                            }}
                            value={searchTerm}
                            onChange={this.handleSearchChange.bind(this)}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item sm={6} xs={12}>
                        <Button
                          variant="outlined"
                          className={classes.filterButton}
                          onClick={() => this.handleFiltersClick()}
                        >
                          {filtersShown ? 'Hide Filters' : 'Show Filters'}
                        </Button>
                        <IconButton
                          className={classes.refresh}
                          aria-label="Refresh"
                        >
                          <RefreshIcon />
                        </IconButton>
                        {filtersShown && (
                          <Button
                            variant="contained"
                            color="primary"
                            className={classes.applyFilterButton}
                            onClick={this.applyFilters.bind(this)}
                          >
                            Apply Filters
                          </Button>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* <Grid item md={4} xs={12}>
                    <Grid
                      container
                      className={classes.gridSort}
                      alignItems="center"
                      spacing={1}
                    >
                      <Grid item>
                        <Typography variant="h5">Sort By</Typography>
                      </Grid>
                      <Grid item>
                        <FormControl variant="filled" className={classes.sort}>
                          <Select
                            value={sort}
                            onChange={e => this.handleChangeSort(e)}
                            input={<FilledInput name="sort" labelWidth={0} />}
                          >
                            <MenuItem value="newest">Newest</MenuItem>
                            <MenuItem value="oldest">Oldest</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Grid> */}
                </Grid>
                <Grid>
                  <ExpansionPanel
                    className={classes.expandPanel}
                    expanded={filtersShown}
                  >
                    <ExpansionPanelSummary
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    />
                    <ExpansionPanelDetails>
                      <Grid container direction="row" spacing={2}>
                        <Grid container item direction="column" lg={2} sm={4}>
                          <Box minHeight={filterTitleHeight * 2}>
                            <RootRef rootRef={this.filterTitleRef}>
                              <Typography variant="h6">REWARD TYPE</Typography>
                            </RootRef>
                          </Box>
                          <RadioGroup
                            className={classes.radioGroup}
                            onChange={this.rewardTypeHandler.bind(this)}
                            value={rewardType}
                          >
                            <FormControlLabel
                              value="any"
                              control={
                                <Radio
                                  color="primary"
                                  icon={<RadioIcon htmlColor={grey} />}
                                  checkedIcon={
                                    <RadioFillIcon htmlColor={grey} />
                                  }
                                />
                              }
                              label="Any"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="money"
                              control={
                                <Radio
                                  color="primary"
                                  icon={<RadioIcon htmlColor={grey} />}
                                  checkedIcon={
                                    <RadioFillIcon htmlColor={grey} />
                                  }
                                />
                              }
                              label="Money"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="product"
                              control={
                                <Radio
                                  color="primary"
                                  icon={<RadioIcon htmlColor={grey} />}
                                  checkedIcon={
                                    <RadioFillIcon htmlColor={grey} />
                                  }
                                />
                              }
                              label="Product"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="productAndMoney"
                              control={
                                <Radio
                                  color="primary"
                                  icon={<RadioIcon htmlColor={grey} />}
                                  checkedIcon={
                                    <RadioFillIcon htmlColor={grey} />
                                  }
                                />
                              }
                              label="Money + Product"
                              labelPlacement="end"
                            />
                          </RadioGroup>
                        </Grid>
                        <Grid container item direction="column" lg={2} sm={4}>
                          <Box minHeight={filterTitleHeight * 2}>
                            <Typography variant="h6">
                              INFLUENCE REQUIRED
                            </Typography>
                          </Box>
                          <RadioGroup
                            className={classes.radioGroup}
                            onChange={this.influenceHandler.bind(this)}
                            value={influenceLevel}
                          >
                            <FormControlLabel
                              value="any"
                              control={
                                <Radio
                                  color="primary"
                                  icon={<RadioIcon htmlColor={grey} />}
                                  checkedIcon={
                                    <RadioFillIcon htmlColor={grey} />
                                  }
                                />
                              }
                              label="Any"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="micro"
                              control={
                                <Radio
                                  color="primary"
                                  icon={<RadioIcon htmlColor={grey} />}
                                  checkedIcon={
                                    <RadioFillIcon htmlColor={grey} />
                                  }
                                />
                              }
                              label="Micro (1K+)"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="macro"
                              control={
                                <Radio
                                  color="primary"
                                  icon={<RadioIcon htmlColor={grey} />}
                                  checkedIcon={
                                    <RadioFillIcon htmlColor={grey} />
                                  }
                                />
                              }
                              label="Macro (10K+)"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="mega"
                              control={
                                <Radio
                                  color="primary"
                                  icon={<RadioIcon htmlColor={grey} />}
                                  checkedIcon={
                                    <RadioFillIcon htmlColor={grey} />
                                  }
                                />
                              }
                              label="Mega (100K+)"
                              labelPlacement="end"
                            />
                          </RadioGroup>
                        </Grid>
                        <Grid container item direction="column" lg={2} sm={4}>
                          <Box minHeight={filterTitleHeight * 2}>
                            <Typography variant="h6">GENDER</Typography>
                          </Box>
                          <RadioGroup
                            className={classes.radioGroup}
                            onChange={this.genderHandler.bind(this)}
                            value={gender}
                          >
                            <FormControlLabel
                              value="any"
                              control={
                                <Radio
                                  color="primary"
                                  icon={<RadioIcon htmlColor={grey} />}
                                  checkedIcon={
                                    <RadioFillIcon htmlColor={grey} />
                                  }
                                />
                              }
                              label="Any"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="male"
                              control={
                                <Radio
                                  color="primary"
                                  icon={<RadioIcon htmlColor={grey} />}
                                  checkedIcon={
                                    <RadioFillIcon htmlColor={grey} />
                                  }
                                />
                              }
                              label="Male"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="female"
                              control={
                                <Radio
                                  color="primary"
                                  icon={<RadioIcon htmlColor={grey} />}
                                  checkedIcon={
                                    <RadioFillIcon htmlColor={grey} />
                                  }
                                />
                              }
                              label="Female"
                              labelPlacement="end"
                            />
                          </RadioGroup>
                        </Grid>
                        <Grid container item direction="column" lg={4} sm={4}>
                          <Box minHeight={filterTitleHeight * 2}>
                            <Typography variant="h6">CONTENT TYPE</Typography>
                          </Box>
                          <TextField
                            id="industry"
                            name="industry"
                            select
                            onChange={this.changeFilterHandler}
                            className={classes.select}
                            SelectProps={{
                              MenuProps: {
                                className: classes.industryMenu
                              }
                            }}
                            margin="normal"
                            variant="outlined"
                            value={filters.industry}
                          >
                            {['All', ...industrySelections].map((item, i) => (
                              <MenuItem key={i} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </TextField>
                          {/* <Box minHeight={filterTitleHeight * 2}>
                            <Typography variant="h6">
                              DEALS COMPLETED
                            </Typography>
                          </Box>
                          <RadioGroup
                            className={classes.radioGroup}
                            onChange={this.dealsHandler.bind(this)}
                            value={dealsCompany}
                          >
                            <FormControlLabel
                              value="0+"
                              control={
                                <Radio
                                  color="primary"
                                  icon={<RadioIcon htmlColor={grey} />}
                                  checkedIcon={
                                    <RadioFillIcon htmlColor={grey} />
                                  }
                                />
                              }
                              label="0+"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="1+"
                              control={
                                <Radio
                                  color="primary"
                                  icon={<RadioIcon htmlColor={grey} />}
                                  checkedIcon={
                                    <RadioFillIcon htmlColor={grey} />
                                  }
                                />
                              }
                              label="1+"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="10+"
                              control={
                                <Radio
                                  color="primary"
                                  icon={<RadioIcon htmlColor={grey} />}
                                  checkedIcon={
                                    <RadioFillIcon htmlColor={grey} />
                                  }
                                />
                              }
                              label="10+"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="100+"
                              control={
                                <Radio
                                  color="primary"
                                  icon={<RadioIcon htmlColor={grey} />}
                                  checkedIcon={
                                    <RadioFillIcon htmlColor={grey} />
                                  }
                                />
                              }
                              label="100+"
                              labelPlacement="end"
                            />
                          </RadioGroup> */}
                        </Grid>
                        {/* <Grid container item direction="column" lg={2} sm={4}>
                          <Box minHeight={filterTitleHeight * 2}>
                            <Typography variant="h6">PLATFORMS</Typography>
                          </Box>
                          <div>
                            <Fab
                              size="small"
                              color="secondary"
                              aria-label="youtube"
                            >
                              <FontAwesomeIcon
                                className={`${classes.icon} ${classes.youtubeIcon}`}
                                icon={faYoutube}
                              />
                            </Fab>
                          </div>
                        </Grid> */}
                        <Grid container item direction="column" lg={2} sm={4}>
                          <Box minHeight={filterTitleHeight * 2}>
                            <Typography variant="h6">MONEY REWARD</Typography>
                          </Box>
                          <div>
                            <OutlinedInputBox
                              id="min"
                              name="minPayout"
                              variant="outlined"
                              value={this.state.filters.payoutMin}
                              onChange={this.payoutMinChangeHandler.bind(this)}
                              type="number"
                            />
                            <Typography variant="body1" align="center">
                              To
                            </Typography>
                            <OutlinedInputBox
                              id="max"
                              name="max"
                              variant="outlined"
                              value={this.state.filters.payoutMax}
                              onChange={this.payoutMaxChangeHandler.bind(this)}
                              type="number"
                            />
                          </div>
                        </Grid>
                      </Grid>
                    </ExpansionPanelDetails>
                    <Divider />
                  </ExpansionPanel>
                </Grid>
              </Grid>
            </Toolbar>
            {tableRows &&
              tableRows.map(row => (
                <Grid
                  key={row.id}
                  className={classes.listRow}
                  container
                  direction="row"
                >
                  <Grid item>
                    <Box mr={2}>
                      <img src={row.picUrl} className={classes.circleImage} />
                    </Box>
                  </Grid>
                  <Grid item container sm xs={12}>
                    <Grid container direction="row">
                      <Grid xs={8}>
                        <Grid container direction="row">
                          <Grid md={6} xs={12}>
                            <Box pr={1}>
                              <LinkText
                                variant="h5"
                                onClick={() =>
                                  this.navigateToCompany(row.companyId)
                                }
                              >
                                {row.companyName}
                              </LinkText>
                            </Box>
                          </Grid>
                          <Grid md={6} xs={12}>
                            <LinkText
                              variant="h5"
                              onClick={() => this.handleCampaignClick(row.id)}
                            >
                              {row.name}
                            </LinkText>
                            {row.micro && (
                              <Typography>Minimum: 100 Followers</Typography>
                            )}
                            {row.macro && !row.micro && (
                              <Typography>Minimum: 10,000 Followers</Typography>
                            )}
                            {row.mega && !row.micro && !row.macro && (
                              <Typography>
                                Minimum: 100,000 Followers
                              </Typography>
                            )}
                            <Typography>
                              <Box color="text.secondary">
                                Location: {row.country}
                              </Box>
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item align="right" xs={4}>
                        <Box pl={1}>
                          {row.commissionOnly && (
                            <Typography color="primary">
                              ${row.payoutMin.toLocaleString()} - $
                              {row.payoutMax.toLocaleString()}
                            </Typography>
                          )}
                          {row.productAndCommission && (
                            <span>
                              <Typography color="primary">
                                ${row.payoutMin.toLocaleString()} - $
                                {row.payoutMax.toLocaleString()}
                                <CardGiftcardIcon color="primary" />
                              </Typography>
                            </span>
                          )}
                          {row.productOnly && (
                            <span>
                              <CardGiftcardIcon color="primary" />
                            </span>
                          )}
                          <Box mt={2}>
                            <Fab
                              size="small"
                              color="secondary"
                              aria-label="youtube"
                            >
                              <FontAwesomeIcon
                                className={`${classes.icon} ${classes.youtubeIcon}`}
                                icon={faYoutube}
                              />
                            </Fab>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                    <Grid />
                    <Grid
                      container
                      direction="row"
                      className={classes.descriptionContainer}
                    >
                      <Box color="text.hint">{row.description}</Box>
                    </Grid>
                  </Grid>
                </Grid>
              ))}
          </Paper>
          <ReactPaginate
            previousLabel={'Prev'}
            nextLabel={'Next'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={pagesCount}
            marginPagesDisplayed={2}
            onPageChange={this.handleChangePage.bind(this)}
            containerClassName={classes.pagination}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
          />
        </main>
      </React.Fragment>
    );
  }
}

Discover.propTypes = {
  campaigns: PropTypes.array
};

export default enhance(Discover);



// WEBPACK FOOTER //
// ./src/components/influencer/Discover.js